<div class="card-view-primary-box app-scrollbar">
  <div class="header row align-items-center">
    <div class="col-11 d-flex align-items-end">
      <div class="col-12 d-flex align-items-center">
        <img src="assets/svg/ico-lock-circle.svg" alt="lock icon" />

        <span class="count pr-10 pl-12">
          {{ activeIssues?.totalCount }}
        </span>

        <div class="dashboard-card-header">
          {{ "ACTIVE_ISSUE" | translate }}
        </div>
      </div>
    </div>

    <hr class="col-12 divider" />
  </div>

  <div class="content position-relative">
    <ng-container *ngIf="activeIssues?.issues?.length === 0">
      <p class="no-record">
        {{ "RECORD_NOT_FOUND" | translate }}
      </p>
    </ng-container>
    <ng-container *ngIf="activeIssues?.issues?.length > 0">
      <div
        class="main-containter"
        *ngFor="
          let activeIssue of activeIssues?.issues | orderBy : '-timestamp';
          let i = index;
          trackBy: trackByOption
        "
      >
        <ng-container *appHideAccess="commonAccessControl">
          <ng-container *ngIf="activeIssue.accessPointId">
            <a
              class="user-item"
              [routerLink]="
                activeIssue.unitId
                  ? navigateToUnitDetail(activeIssue)
                  : navigateToAccessPointDetail(activeIssue)
              "
            >
              <div class="row py-2 mx-2 item pointer-cursor">
                <div class="col-md-2 col-4">
                  <ng-container [ngSwitch]="activeIssue?.eventType">
                    <ng-container *ngSwitchCase="CONSTANTS.FIRMWARE_UPDATE">
                      <img
                        src="assets/svg/ico-alert-red-circle.svg"
                        alt="critical icon"
                      />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <img
                        src="assets/svg/ico-alert-red-circle.svg"
                        alt="critical icon"
                      />
                    </ng-container>
                  </ng-container>
                </div>
                <div class="col-md-6 col-8">
                  <div class="dashboard-list-content">
                    {{ activeIssue?.deviceName }}
                  </div>
                  <div class="status">
                    {{ "UNIT" | translate }} {{ activeIssue?.unitPrefix || ""
                    }}{{ activeIssue?.unitName }}, {{ "BUILDING" | translate }}
                    {{ activeIssue?.buildingName }}
                  </div>
                  <span class="date">
                    <ng-container *ngIf="activeIssue?.isoTime">
                      {{
                        getContentFormatDate(
                          activeIssue?.isoTime,
                          "MMM do, yyyy h:mm a"
                        )
                      }}
                    </ng-container>
                  </span>
                </div>
                <div
                  class="col-md-4 col-12 d-flex px-1 text-right align-self-center justify-content-end"
                >
                  <div class="time">
                    {{ activeIssue?.eventDescription }}
                  </div>
                  <div class="ml-auto align-self-center">
                    <img
                      src="assets/svg/ico-chevron-forward-outline.svg"
                      alt="forward icon"
                    />
                  </div>
                </div>
              </div>
            </a>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="activeIssue.unitId">
          <a
            class="user-item"
            [routerLink]="
              activeIssue.unitId
                ? navigateToUnitDetail(activeIssue)
                : navigateToAccessPointDetail(activeIssue)
            "
          >
            <div class="row py-2 mx-2 item pointer-cursor">
              <div class="col-md-2 col-4">
                <ng-container [ngSwitch]="activeIssue?.eventType">
                  <ng-container *ngSwitchCase="CONSTANTS.FIRMWARE_UPDATE">
                    <img
                      src="assets/svg/ico-alert-red-circle.svg"
                      alt="critical icon"
                    />
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <img
                      src="assets/svg/ico-alert-red-circle.svg"
                      alt="critical icon"
                    />
                  </ng-container>
                </ng-container>
              </div>
              <div class="col-md-6 col-8">
                <div class="dashboard-list-content">
                  {{ activeIssue?.deviceName }}
                </div>
                <div class="status">
                  {{ "UNIT" | translate }}
                  {{ activeIssue?.unitPrefix || ""
                  }}{{ activeIssue?.unitName }}, {{ "BUILDING" | translate }}
                  {{ activeIssue?.buildingName }}
                </div>
                <span class="date">
                  <ng-container *ngIf="activeIssue?.isoTime">
                    {{
                      getContentFormatDate(
                        activeIssue?.isoTime,
                        "MMM do, yyyy h:mm a"
                      )
                    }}
                  </ng-container>
                </span>
              </div>
              <div
                class="col-md-4 col-12 d-flex px-1 text-right align-self-center justify-content-end"
              >
                <div class="time">
                  {{ activeIssue?.eventDescription }}
                </div>
                <div class="ml-auto align-self-center">
                  <img
                    src="assets/svg/ico-chevron-forward-outline.svg"
                    alt="forward icon"
                  />
                </div>
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <a
    [ngClass]="
      activeIssues?.totalCount > dashboardManagementService.maxCardRecords
        ? 'visible'
        : 'invisible'
    "
    class="view-all-btn d-flex justify-content-center align-items-center"
  >
    <span [routerLink]="['active-issues']">
      <p class="mt-1 mb-0 pointer-cursor">{{ "VIEW_ALL" | translate }}</p>
    </span>
  </a>
</div>
